export const stringToMoney = (value) => {
  if (!value) {
    return 0;
  }
  let dollar = value?.split(',')?.[0],
    pennys = value?.split(',')?.[1];
  dollar = dollar.replace(/\D/g, '');
  return parseFloat(dollar + '.' + (pennys ?? 0));
};

export const getFullMoney = (value) => {
  value += '';
  if (!value) {
    return '';
  }
  if (!value.includes('.')) {
    return value + '.00';
  }
  return value;
};

export const moneyAddZeros = (money) => {
  if (money === null || money === undefined || money === '') {
    return '0,00';
  }

  const numValue = Number(money);
  if (isNaN(numValue) || !isFinite(numValue)) {
    return '0,00';
  }

  money = numValue.toString();

  if (!money.includes('.')) {
    return money + ',00';
  } else {
    let [real, cent] = money.split('.');
    if (cent.length === 1) {
      cent += '0';
    }
    return real + ',' + cent;
  }
};
